import { Accordion } from './Accordion'
import { useTranslation } from 'utils/useTranslation'

export function Accordions({ specifications, fits }) {
  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  return (
    <div className='mtt-accordions'>
      <Accordion list={specifications} title={accessoryStrings.specifications} />
      <Accordion list={fits} title={accessoryStrings.fits_to} />
    </div>
  )
}
